import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

export function RouteError() {
  const err = useRouteError();
  const notFound = isRouteErrorResponse(err) && err.status === 404;
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="font-display text-5xl font-extrabold">{notFound ? 'Página não encontrada' : 'Algo deu errado'}</p>
      <p className="text-sm text-muted-foreground">
        {notFound ? 'O endereço pode ter mudado.' : 'Recarregue a página. Se continuar, avise o suporte.'}
      </p>
      <Link to="/app" className="text-sm font-medium text-primary underline-offset-4 hover:underline">
        Ir para o painel
      </Link>
    </div>
  );
}
